import { useSelector } from 'react-redux'
function MessageZone()
{
    const gameEnded = useSelector(state => state.game.gameEnded);
    if (gameEnded) {
       //setTimeout(alert("You win!"), 1500);
        const divMessage = document.getElementById("divMessage");
        divMessage.innerText = "You win!"
    }
}
export default MessageZone;